/**
 * Approved public professional information ONLY.
 * Data minimization: no residential address, no license number, no license
 * expiration, no personal email or personal phone numbers.
 */

export const AGENT_DISPLAY_NAME = 'VERONICA GOMEZ SANTANA'
export const AGENT_ROLE_EN = 'REAL ESTATE PROFESSIONAL'
export const AGENT_ROLE_ES = 'PROFESIONAL INMOBILIARIA'
export const BROKERAGE_NAME = 'Avanti Way Realty LLC'
export const AFFILIATION_EN = 'AFFILIATED WITH AVANTI WAY REALTY LLC'
export const AFFILIATION_ES = 'AFILIADA A AVANTI WAY REALTY LLC'

export const BUSINESS_PHONE_DISPLAY = '678-577-6949'
export const BUSINESS_PHONE_HREF = 'tel:+16785776949'
export const BUSINESS_EMAIL = 'Verogomez@avantiway.com'
export const BUSINESS_EMAIL_HREF = 'mailto:Verogomez@avantiway.com'
export const WHATSAPP_URL = 'https://wa.me/16785776949'

export const OFFICIAL_PROFILE_URL = 'https://search.avantiway.com/Verogomez'
export const OFFICIAL_LISTING_URL =
  'https://search.avantiway.com/listing-view/O6415042?state=7cef8a734855777c2a9d0caf42666e69'
export const ZILLOW_LISTING_URL =
  'https://www.zillow.com/homedetails/Davenport-FL-33896/401734828_zpid/'
export const BROKERAGE_WEBSITE_URL = 'https://www.avantiway.com'

export const PROPERTY_ADDRESS = '1039 Plantation Ln, Davenport, FL 33896'
export const PROPERTY_PRICE_DISPLAY = '$390,000'
export const PROPERTY_PRICE_NUMERIC = 390000
export const GOOGLE_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=1039+Plantation+Ln+Davenport+FL+33896'
export const SITE_URL = 'https://verogrealtor.com'

/**
 * Brand asset gate. Set to false to suppress every logo image and fall back to
 * text-only brokerage identification until written authorization is on file.
 */
export const BRAND_ASSETS_AUTHORIZED = true

export const LOGO_AVANTI_WHITE =
  'https://cdn.magicpatterns.com/uploads/wnDbf9PU5srvaTjDv5qaGv/AVANTI-WAY-logo-white.png'
export const LOGO_AVANTI_COLOR =
  'https://cdn.magicpatterns.com/uploads/4Un4mVttHrFR9kwcd8MGrU/AVANTI-WAY-logo-color.png'
export const LOGO_VERO_MEDALLION =
  'https://cdn.magicpatterns.com/uploads/dQdKsvCd6hkudybPWhSc4a/VERO-logo-3D-circular.png'

/**
 * Replaceable portrait field. Paste the original high-resolution professional
 * portrait URL here (EXIF/GPS metadata stripped before upload). While empty,
 * the agent section renders without a portrait frame — no public placeholder,
 * no generated or substitute likeness.
 */
export const AGENT_PORTRAIT_URL = ''
